import './main.scss';
// TODO: Look into why this isn't working
// import 'grapesjs/dist/css/grapes.min.css';

import grapesjs, {type Editor} from 'grapesjs';
import GRAPESJS_CONFIG from "./grapesjs-email-editor-plugin/configs/grapesjs";

async function initializeEditor(): Promise<Editor> {
    await new Promise<void>(resolve => { window.PMW.initI18next(window.PMW.LANGUAGE, resolve); });
    return grapesjs.init(GRAPESJS_CONFIG as any);
}

export default initializeEditor();
